var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'LandingPage' }}},[_c('div',{class:{
      'logo-space-width': !_vm.smallLogo
    }},[_c('div',{class:[
        _vm.smallLogo ? 'small-logo-wrapper' : 'large-logo',
        _vm.$federation.logo.backgroundColor
      ]},[_c('img',{attrs:{"src":_vm.$federation.logo.image,"alt":_vm.$federation.logo.label,"role":"img"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }